import { FromDtoFn } from "../../../../../types/FromDtoFn.type";
import { LevelsGetResponse as ResGet } from "../../../redux/api/types/GET";
import { convertToServerResponse } from "../../../../../services/utils.service/convertToServerResponse";
import COMMON_FIELDS from "../../../../../../../general/constants/commonFields";
import convertMyReferralSystem from "./utils/convertMyReferralSystem.util";
import convertMyTransactions from "./utils/convertMyTransactions.util";

export namespace LoyaltyProgramFromDtoGet {
	export const getMLevels: FromDtoFn<ResGet.MyLevelGet> = (props, meta) => {
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: props,
			  })
			: null;
	};

	export const getMyReferralSystem: FromDtoFn<ResGet.MyReferralSystemGet> = (
		props,
		meta
	) => {
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: convertMyReferralSystem(props),
			  })
			: null;
	};

	export const getMyTransactions: FromDtoFn<ResGet.MyTransactionsGet> = (
		props,
		meta
	) => {
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.COUNT]: props?.[COMMON_FIELDS.COUNT] as number,
					[COMMON_FIELDS.PAGE_COUNT]: props?.[COMMON_FIELDS.PAGE_COUNT],
					[COMMON_FIELDS.CURRENT_PAGE]: props?.[COMMON_FIELDS.CURRENT_PAGE],
					[COMMON_FIELDS.DATA]: convertMyTransactions(props),
			  })
			: null;
	};
}
